
export enum CookReferenceModelName {
    COOK_SUBSCRIPTION_V3 = "COOK_SUBSCRIPTION_V3",
    ONE_MEAL_SERVICE = "ONE_MEAL_SERVICE",
    TRIALS_V3 = "TRIALS_V3",
    CHEF_FOR_PARTY = "CHEF_FOR_PARTY" 
}